// Border Style Plugin
import { createColorProperty } from './helpers.js';

export default {
    id: 'border',
    label: 'Border',
    icon: 'Square',
    properties: {
        borderRadius: {
            label: 'Radius',
            type: 'select',
            options: ['none', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', 'full'],
            default: 'md',
            toClass: (value) => value ? `rounded-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^rounded-(.+)$/);
                return match ? match[1] : null;
            }
        },
        borderWidth: {
            label: 'Width',
            type: 'select',
            options: ['0', '1', '2', '4', '8'],
            default: '1',
            toClass: (value) => value && value !== '0' ? (value === '1' ? 'border' : `border-${value}`) : null,
            fromClass: (className) => {
                if (className === 'border') return '1';
                const match = className.match(/^border-(\d+)$/);
                return match ? match[1] : null;
            }
        },
        borderColor: {
            label: 'Color',
            type: 'color',
            default: null,
            ...createColorProperty('border', ['0', '2', '4', '8'])
        },
        borderStyle: {
            label: 'Style',
            type: 'select',
            options: ['solid', 'dashed', 'dotted', 'double', 'none'],
            default: 'solid',
            toClass: (value) => value ? `border-${value}` : null,
            fromClass: (className) => {
                const match = className.match(/^border-(solid|dashed|dotted|double|none)$/);
                return match ? match[1] : null;
            }
        }
    }
};
